import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import gmapsIconSrc from '@chama/statics/assets/img/google-maps-icon.png';
import Modal, { SIZES } from '../Modal';
import { Map } from '../GoogleMaps';
import './index.css';

const propTypes = {
  markers: PropTypes.array.isRequired,
  onClick: PropTypes.func,
};

const defaultProps = {
  onClick: () => {},
};

class MapThumbBtn extends Component {
  render() {
    const { markers, onClick } = this.props;
    const onMapBtnClick = () => {
      this.modal.show();
      onClick();
    };

    return (
      <button className="MapThumbBtn" onClick={onMapBtnClick}>
        <div className="MapThumbBtn__image_wrapper">
          <img src={gmapsIconSrc} width="120px" alt="google maps icon thumbnail" />
        </div>
        <Modal
          size={SIZES.X_LARGE}
          confirmButtonText={<FormattedMessage id="closeLabel" defaultMessage="Close" />}
          ref={ref => {
            this.modal = ref;
          }}
        >
          <Map className="MapThumbBtn__map" markers={markers} />
        </Modal>
      </button>
    );
  }
}

MapThumbBtn.propTypes = propTypes;
MapThumbBtn.defaultProps = defaultProps;

export default MapThumbBtn;



// WEBPACK FOOTER //
// ../ui-components/components/MapThumbBtn/index.jsx